import axios from "axios";
import { allSystems } from "@/constants";

export default {
    name: "resumen",
    components: {},
    data() {
        return {
            headers: [
                {
                    text: "Sistema",
                    align: "left",
                    value: "sistema"
                },
                {
                    text: "Descripción",
                    align: "left",
                    value: "descripcion"
                },
                {
                    text: "Último Mantenimiento",
                    value: "ultimo"
                },
                {
                    text: "Válido hasta",
                    value: "vencimiento"
                },
                {
                    text: "Alertas",
                    value: "alertas",
                    align: "right"
                }
            ],
            search: "",
            soloAlertas: false,
            soloVencidos: false,
            historia: []
        };
    },

    computed: {
        loggedIn() {
            return localStorage.loggedIn;
        },

        historiaFiltrada() {
            const contiene = (fila, texto) =>
                fila.sistema.toLowerCase().includes(texto.toLowerCase()) || fila.descripcion.toLowerCase().includes(texto.toLowerCase());

            // filtro por texto
            let filtrado = this.historia.filter(instalacion => contiene(instalacion, this.search));

            // me quedo con las vencidas
            if (this.soloVencidos) {
                filtrado = filtrado.filter(instalacion => this.getColorAndIcon(instalacion.vencimiento).color === "red");
            }
            if (this.soloAlertas) {
                filtrado = filtrado.filter(instalacion => instalacion.alertas > 0);
            }

            return filtrado;
        }
    },

    async mounted() {
        if (!localStorage.loggedIn) {
            const loginpath = window.location.pathname;
            this.$router.push({ name: "acceso", query: { redirect: loginpath } });
            return;
        }

        try {
            const promise1 = axios.get(allSystems(localStorage.userToken));
            const datos1 = await promise1;
            const result1 = datos1.data || [];

            this.historia = result1.map(r => ({
                systemId: r.system_id,
                sistema: r.fantasy_name,
                descripcion: r.system_description,
                ultimo: Array.isArray(r.last_system_maintenance) ? "No registra mantenimientos" : r.last_system_maintenance.maintenance_date,
                vencimiento: Array.isArray(r.last_system_maintenance)
                    ? "No registra mantenimientos"
                    : r.last_system_maintenance.maintenance_valid_until,
                alertas: r.alerts
            }));
        } catch (e) {
            window.console.log("ERROR!!", e);
        }
    },

    methods: {
        agregarSistemaClick() {
            this.$router.push("/sistemanuevo");
        },

        volverClick() {
            this.$router.go(-1);
        },

        verSistema(p) {
            this.$router.push("/sistema/" + p.item.systemId);
        },

        verDetalle(p) {
            this.$router.push("/detalle/" + p.item.systemId);
        },

        getColorAndIcon(date = "") {
            const wrong = {
                icon: "cancel",
                color: "red"
            };

            const warning = {
                icon: "error",
                color: "orange"
            };

            const okay = {
                icon: "check_circle",
                color: "green"
            };

            if (date === "No registra mantenimientos") {
                return wrong;
            } else {
                const today = new Date();
                const mantainanceDate = new Date(date);
                if (mantainanceDate < today) {
                    return wrong;
                } else {
                    // we compare with 1 months from now
                    let oneMonthFromNow = new Date();
                    oneMonthFromNow = oneMonthFromNow.setMonth(today.getMonth() + 1);
                    return mantainanceDate < oneMonthFromNow ? warning : okay;
                }
            }
        },

        getColorAndIconAlerts(count = 0) {
            const wrong = {
                icon: "cancel",
                color: "red"
            };

            const okay = {
                icon: "check_circle",
                color: "green"
            };

            if (count != 0) {
                return wrong;
            } else {
                return okay;
            }
        }
    }
};
